import { useCallback, useEffect, useRef, useState } from "react";

import { Tooltip, Box, Link } from "@mui/material";

const EllipsisText = ({
    text,
    width = "150px",
    controlMobile = false,
    href = undefined,
}) => {
    const elementRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    const measure = useCallback(() => {
        const el = elementRef.current;
        if (!el) return;
        setIsTruncated(el.scrollWidth > el.clientWidth);
    }, []);

    useEffect(() => {
        measure();

        const el = elementRef.current;
        if (!el || typeof ResizeObserver === "undefined") return;

        const observer = new ResizeObserver(measure);
        observer.observe(el);

        return () => observer.disconnect();
    }, [measure, text, width]);

    const ellipsisSx = {
        display: "inline-block",
        maxWidth: width,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        verticalAlign: "middle",
        ...(controlMobile && {
            "@media (max-width: 600px)": {
                overflow: "visible",
                whiteSpace: "nowrap",
                textOverflow: "unset",
                maxWidth: "none",
            },
        }),
    };

    return (
        <Tooltip title={isTruncated ? text : ""}>
            {href ? (
                <Link
                    ref={elementRef}
                    target="_blank"
                    href={href}
                    color="textPrimary"
                    sx={ellipsisSx}
                >
                    {text}
                </Link>
            ) : (
                <Box ref={elementRef} component="span" sx={ellipsisSx}>
                    {text}
                </Box>
            )}
        </Tooltip>
    );
};

export default EllipsisText;
